 export const CART_REQUEST = "CART_REQUEST"
 export const CART_SUCCESS = "CART_SUCCESS"
 export const CART_FAILURE = "CART_FAILURE"

export const ADD_CART_REQUEST = "ADD_CART_REQUEST";
export const ADD_CART_SUCCESS = "ADD_CART_SUCCESS";
export const ADD_CART_FAILURE = "ADD_CART_FAILURE";

export const DELETE_CART_REQUEST = "DELETE_CART_REQUEST" ;
export const DELETE_CART_SUCCESS = "DELETE_CART_SUCCESS" ;
export const DELETE_CART_FAILURE = "DELETE_CART_FAILURE" ;
